import type { ScoreboardsState } from '../../types/scoreboards';

const scoreboardsNetworkError = (state: ScoreboardsState): ScoreboardsState => ({
  ...state,
  hasNetworkError: true
});

export default scoreboardsNetworkError;
